import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '../store/authStore'
import { supabase } from '../lib/supabase'

// Plumbing only — page gating (S3) will consume this. Nothing reads it yet.
//
// Enforcement is active ONLY when BOTH:
//   1. the global kill-switch (platform_settings.enforce_plans_enabled) is on, AND
//   2. the tenant's enforce_plan_limits flag is true.
//
// Defaults to enforced = false safely: if either value is missing or still
// loading, the tenant is treated as NOT enforced.
export function useEnforcement(): { enforced: boolean; loading: boolean } {
  const { tenant } = useAuthStore()

  const { data: globalEnabled, isLoading } = useQuery<boolean>({
    queryKey: ['enforce-plans-enabled'],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      try {
        const { data } = await supabase
          .from('platform_settings')
          .select('value')
          .eq('key', 'enforce_plans_enabled')
          .maybeSingle()
        return data?.value === 'true'
      } catch {
        return false
      }
    },
  })

  const tenantEnforced = tenant?.enforce_plan_limits === true
  const enforced = globalEnabled === true && tenantEnforced

  return { enforced, loading: isLoading }
}
